import { render, staticRenderFns } from "./StartFolders.vue?vue&type=template&id=0ee7c4c7&scoped=true"
import script from "./StartFolders.vue?vue&type=script&lang=js"
export * from "./StartFolders.vue?vue&type=script&lang=js"
import style0 from "./StartFolders.vue?vue&type=style&index=0&id=0ee7c4c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee7c4c7",
  null
  
)

export default component.exports